import { defaultTownAvatarAppearance, type ClothColorId, type HairColorId, type TownAvatarAppearance } from "@town/contracts";

function look(preset: number, hair: HairColorId, top: ClothColorId, bottom?: ClothColorId): TownAvatarAppearance {
  const base = defaultTownAvatarAppearance(preset);
  return {
    ...base,
    hair: { ...base.hair, color: hair },
    top: { ...base.top, color: top },
    bottom: base.bottom && bottom ? { ...base.bottom, color: bottom } : base.bottom,
  };
}

/** Eight distinct people built from the six wardrobe presets. The player picks one; coworkers wear the rest. */
export const LANDING_LOOKS: readonly TownAvatarAppearance[] = [
  look(0, "espresso", "sky", "navy"),
  look(1, "black", "coral", "charcoal"),
  look(2, "pink", "lilac", "charcoal"),
  look(3, "chestnut", "sage", "denim"),
  look(4, "blonde", "mustard", "navy"),
  look(5, "black", "teal", "charcoal"),
  look(0, "ginger", "orange", "denim"),
  look(2, "blue", "white", "navy"),
];
